import { performRequest } from './api-handler';
import { URLS } from '../utility/urls'

export default () => {
    const { 
        GET_EWALLET_SETTING_DETAILS,
        PUT_EWALLET_SETTING_DETAILS,
        POST_EWALLET_SETTING_DETAILS,
     } = URLS;
    return {
        getWalletDetails: (body = {}, method = 'get', query) =>
            performRequest(method ? method : 'get', GET_EWALLET_SETTING_DETAILS, body),
        postWalletDetails: (body = {}, method = 'post', query) =>
            performRequest(method ? method : 'post', POST_EWALLET_SETTING_DETAILS, body),
        putWalletDetails: (body = {}, method = 'put', query) =>
            performRequest(method ? method : 'put', PUT_EWALLET_SETTING_DETAILS.replace(':_id',body._id), body),
    }
}




